import React from 'react';
import { Card, Button, Popconfirm } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import cn from 'classnames';

import Description from './InfoBlocks/Description';
import Status from './InfoBlocks/Status';
import Sync from './InfoBlocks/Sync';
import Platform from './InfoBlocks/Platform';
import Orientation from './InfoBlocks/Orientation';

function DevicesItem({
  t,
  name,
  landscape,
  version = '',
  platform,
  problemSync,
  description,
  isActivate,
  lastOnline,
  online,
  lastSync,
  pin,
  active,
  loading,
  onClick,
  onDelete,
  percent,
}) {
  return (
    <Card
      className={cn('device-container', {
        'device-container--active': active,
        'device-container--loading': loading,
      })}
      onClick={onClick}
    >
      <div className="device">
        <div className="device__info device-info">
          <div className="device-info__header device-info-header">
            <div className="device-info-header__title">{name}</div>
            <Description
              t={t}
              description={description}
              isActivate={isActivate}
              pin={pin}
            />
          </div>
          <div className="device-info__content device-info-content">
            <Status
              t={t}
              isActivate={isActivate}
              online={online}
              lastOnline={lastOnline}
            />
            <Sync
              t={t}
              problemSync={problemSync}
              lastSync={lastSync}
              percent={percent}
            />
            <Platform platform={platform} version={version} />
            <Orientation landscape={landscape} />
          </div>
        </div>
        <div className="device__actions device-actions">
          <Popconfirm
            placement="left"
            title={t('delete-device-warning')}
            cancelText={t('to-leave')}
            okText={t('delete')}
            onConfirm={onDelete}
          >
            <Button
              onClick={(e) => e.stopPropagation()}
              className="device-actions__delete"
              type="link"
              icon={<DeleteOutlined />}
            />
          </Popconfirm>
        </div>
      </div>
    </Card>
  );
}

export default DevicesItem;
